import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { canView } from "./lib/permissions";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import CapturaVentas from "./pages/CapturaVentas";
import CapturaGastos from "./pages/CapturaGastos";
import HistorialVentas from "./pages/HistorialVentas";
import HistorialGastos from "./pages/HistorialGastos";
import ConsultaFecha from "./pages/ConsultaFecha";
import ReporteSemanal from "./pages/ReporteSemanal";
import ReporteMensual from "./pages/ReporteMensual";
import EstadoResultados from "./pages/EstadoResultados";
import CierreDiario from "./pages/CierreDiario";
import Productos from "./pages/Productos";
import GastosOperativos from "./pages/GastosOperativos";
import Usuarios from "./pages/Usuarios";
import "./App.css";

// Orden de prioridad para landing automática
const LANDING_ORDER = [
  ["dashboard", "/dashboard"],
  ["captura_ventas", "/captura-ventas"],
  ["captura_gastos", "/captura-gastos"],
  ["historial_ventas", "/historial-ventas"],
  ["historial_gastos", "/historial-gastos"],
  ["consulta_fecha", "/consulta-fecha"],
  ["reporte_semanal", "/reporte-semanal"],
  ["reporte_mensual", "/reporte-mensual"],
  ["estado_resultados", "/estado-resultados"],
  ["cierre_diario", "/cierre-diario"],
  ["productos", "/productos"],
  ["gastos_operativos", "/gastos-operativos"],
];

const Root = () => {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "admin") return <Navigate to="/dashboard" replace />;
  for (const [sec, path] of LANDING_ORDER) {
    if (canView(user, sec)) return <Navigate to={path} replace />;
  }
  return <Navigate to="/sin-acceso" replace />;
};

const Page = ({ children, seccion, adminOnly = false }) => (
  <ProtectedRoute seccion={seccion} adminOnly={adminOnly}>
    <Layout>{children}</Layout>
  </ProtectedRoute>
);

const SinAcceso = () => (
  <Layout>
    <div className="text-center py-20">
      <h1 className="text-3xl font-bold tracking-tight">Sin acceso</h1>
      <p className="text-sm text-slate-500 mt-2">
        Tu usuario no tiene permisos asignados aún. Contacta al administrador.
      </p>
    </div>
  </Layout>
);

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Root />} />
          <Route path="/login" element={<Login />} />
          <Route path="/sin-acceso" element={<ProtectedRoute><SinAcceso /></ProtectedRoute>} />
          <Route path="/dashboard"          element={<Page seccion="dashboard"><Dashboard /></Page>} />
          <Route path="/captura-ventas"     element={<Page seccion="captura_ventas"><CapturaVentas /></Page>} />
          <Route path="/captura-gastos"     element={<Page seccion="captura_gastos"><CapturaGastos /></Page>} />
          <Route path="/historial-ventas"   element={<Page seccion="historial_ventas"><HistorialVentas /></Page>} />
          <Route path="/historial-gastos"   element={<Page seccion="historial_gastos"><HistorialGastos /></Page>} />
          <Route path="/consulta-fecha"     element={<Page seccion="consulta_fecha"><ConsultaFecha /></Page>} />
          <Route path="/reporte-semanal"    element={<Page seccion="reporte_semanal"><ReporteSemanal /></Page>} />
          <Route path="/reporte-mensual"    element={<Page seccion="reporte_mensual"><ReporteMensual /></Page>} />
          <Route path="/estado-resultados"  element={<Page seccion="estado_resultados"><EstadoResultados /></Page>} />
          <Route path="/cierre-diario"      element={<Page seccion="cierre_diario"><CierreDiario /></Page>} />
          <Route path="/productos"          element={<Page seccion="productos"><Productos /></Page>} />
          <Route path="/usuarios"           element={<Page adminOnly><Usuarios /></Page>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
